import type { LucideIcon } from 'lucide-react';

interface ValueCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  gradient: string;
}

export function ValueCard({ icon: Icon, title, description, gradient }: ValueCardProps) {
  return (
    <div className="group relative h-full">
      <div className="absolute -inset-0.5 rounded-2xl bg-gradient-to-br opacity-0 group-hover:opacity-100 blur transition-opacity duration-500" />
      <div className="relative bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl p-6 h-full flex flex-col">
        <div
          className={`w-12 h-12 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center mb-4 shadow-lg`}
        >
          <Icon className="w-6 h-6 text-white" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">{title}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed flex-1">
          {description}
        </p>
      </div>
    </div>
  );
}
